import { render } from "./ErrorMessage.vue?vue&type=template&id=3fbe4e88"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__